<template>
  <div class="sticky-header">
    <header class="d-none">
      <div class="top-header">
        <div class="row flex justify-between items-center w-100 m-0">
          <div>
            <div class="flex items-center gap-2">
              <div class="top-left-buttons">
                <a
                  href="https://awinet.org/home/"
                  class="top-bar-buttons with-border-btn btn-hover-state"
                  >AWI</a
                >
                <a
                  :href="`${this.redirectUrl}`"
                  class="top-bar-buttons with-bg-btn btn-hover-state"
                  >QCP</a
                >
              </div>
            </div>
          </div>
          <div class="pr-0">
            <div class="flex gap-8 top-bar-links items-center">
              <div class="top-bar-menu-links">
                <ul class="navbar-nav mr-auto flex flex-row gap-6 items-center">
                  <li class="nav-item active">
                    <a class="nav-link" :href="`${this.redirectUrl}faq/`"
                      >FAQ</a
                    >
                  </li>
                  <li class="nav-item active">
                    <a class="nav-link" :href="`${this.redirectUrl}contact/`"
                      >Contact</a
                    >
                  </li>

                  <li
                    class="nav-item dropdown dropdown-hover"
                    v-if="this.userDetails !== null"
                  >
                    <a
                      class="nav-link dropdown-toggle flex items-center gap-2"
                      href="#"
                      id="navbarDropdown"
                      role="button"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Account
                      <d-icon
                        class="menu-chevron-down"
                        icon="chevron-down"
                        type="is-primary is-clickable"
                      />
                    </a>
                    <div class="sub-menu" aria-labelledby="navbarDropdown">
                      <a class="dropdown-item no-underline" href="/admin"
                        >Admin</a
                      >
                      <a
                        class="dropdown-item no-underline"
                        href="/account/logout"
                        >Log Out</a
                      >
                    </div>
                  </li>
                  <li class="nav-item" v-if="this.userDetails === null">
                    <a
                      class="nav-link"
                      href="/account/login"
                      tabindex="-1"
                      aria-disabled="true"
                    >
                      Login
                    </a>
                  </li>
                </ul>
              </div>
              <!-- <div class="top-bar-search">
                              <input type="search" name="search" placeholder="Search" v-model="search"
                                @keyup.enter="handleSearch(search)" required />
                              <d-icon class="top-bar-search-icon" icon="search" type="is-primary is-clickable"
                                @click="handleSearch(search)" />
                            </div>
                            <div class="top-bar-number">
                              <span> <d-icon icon="phone" /></span>
                              855-345-0991
                            </div> -->
            </div>
          </div>
        </div>
      </div>
      <div class="header">
        <nav
          id="navbar"
          class="sticky-top top-0 inset-x-0 items-center main-nav-des"
        >
          <div class="w-full relative mx-auto">
            <div
              class="flex flex-wrap xl:flex-no-wrap items-center justify-between px-0 F"
            >
              <div class="flex items-center xl:mr-4 py-2">
                <a
                  :href="`${this.redirectUrl}`"
                  class="no-underline text-xl font-bold"
                >
                  <img
                    src="/dist/images/logo.jpg"
                    class="max-w-none"
                    alt="AWI Quality Certification Program"
                    width="150"
                  />
                </a>
              </div>
              <div class="flex items-center gap-3">
                <div class="block hidden">
                  <button
                    class="navbar-burger flex items-center px-3 py-2 border rounded text-black border-black hover:text-black hover:border-black"
                    @click="showNavLinks = !showNavLinks"
                  >
                    <svg
                      class="fill-current h-3 w-3"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Menu</title>
                      <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                    </svg>
                  </button>
                </div>

                <div class="xl:hidden">
                  <div class="relative inline-block text-left">
                    <div>
                      <button
                        type="button"
                        class="ham-menu-btn inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                        id="menu-button"
                        aria-expanded="true"
                        aria-haspopup="true"
                      >
                        <div class="main-menu-hamburger">
                          <label class="burger" for="burger">
                            <input
                              type="checkbox"
                              id="burger"
                              @click="handleClick"
                            />
                            <span></span>
                            <span></span>
                            <span></span>
                          </label>
                        </div>
                      </button>
                    </div>
                    <div
                      class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none res-menu-dropdown"
                      :class="{ hidden: !this.isActive }"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="menu-button"
                      tabindex="-1"
                    >
                      <div class="res-quick-links">
                        <h6 class="mb-3">Menu</h6>
                        <ul
                          class="res-quick-link-list"
                          id="responsive-side-menu"
                        >
                          <li class="res-quick-link-item">
                            <a href="">About</a>
                            <span
                              class="res-dd-right-icon"
                              @click="handleSubMenu('about_menu')"
                            >
                              <d-icon
                                class="res-menu-chevron-right"
                                icon="chevron-right"
                                type="is-primary is-clickable"
                              />
                            </span>
                          </li>
                          <li class="res-quick-link-item">
                            <a href="">Architects</a>
                            <span
                              class="res-dd-right-icon"
                              @click="handleSubMenu('architects_menu')"
                            >
                              <d-icon
                                class="res-menu-chevron-right"
                                icon="chevron-right"
                                type="is-primary is-clickable"
                              />
                            </span>
                          </li>
                          <li class="res-quick-link-item">
                            <a href="">Licensing</a>
                            <span
                              class="res-dd-right-icon"
                              @click="handleSubMenu('licensing_menu')"
                            >
                              <d-icon
                                class="res-menu-chevron-right"
                                icon="chevron-right"
                                type="is-primary is-clickable"
                              />
                            </span>
                          </li>
                          <li class="res-quick-link-item">
                            <a href="">Professionals</a>
                            <span
                              class="res-dd-right-icon"
                              @click="handleSubMenu('professional_menu')"
                            >
                              <d-icon
                                class="res-menu-chevron-right"
                                icon="chevron-right"
                                type="is-primary is-clickable"
                              />
                            </span>
                          </li>
                          <li class="res-quick-link-item">
                            <a href="">Project Resources</a>
                            <span
                              class="res-dd-right-icon"
                              @click="handleSubMenu('presource_menu')"
                            >
                              <d-icon
                                class="res-menu-chevron-right"
                                icon="chevron-right"
                                type="is-primary is-clickable"
                              />
                            </span>
                          </li>
                          <li class="res-quick-link-item">
                            <a href="">More</a>
                            <span
                              class="res-dd-right-icon"
                              @click="handleSubMenu('more_menu')"
                            >
                              <d-icon
                                class="res-menu-chevron-right"
                                icon="chevron-right"
                                type="is-primary is-clickable"
                              />
                            </span>
                          </li>

                          <li
                            class="res-quick-link-item"
                            v-if="this.userDetails === null"
                          >
                            <a href="/account/login">Login</a>
                          </li>
                          <li
                            class="res-quick-link-item"
                            v-if="this.userDetails !== null"
                          >
                            <a href="/admin">Admin</a>
                          </li>
                          <li
                            class="res-quick-link-item"
                            v-if="this.userDetails !== null"
                          >
                            <a href="/account/logout">Logout</a>
                          </li>
                        </ul>

                        <div class="submenu-in-res-dd hidden" id="back-res-ui">
                          <div
                            class="back-btn-res"
                            @click="
                              handleBackBtnRes(
                                'responsive-side-menu',
                                'back-res-ui'
                              )
                            "
                          >
                            ← Back
                          </div>
                          <div>
                            <ul
                              class="res-submenu-list-ui"
                              id="dynamic_menu"
                            ></ul>
                            <ul
                              class="res-submenu-list-ui hidden"
                              id="show_presource"
                            >
                              <li>
                                <a href="/forms/register-project"
                                  >Why Register a Project?</a
                                >
                              </li>
                              <li>
                                <a href="/forms/project-certification"
                                  >Order Project Certification</a
                                >
                              </li>
                              <li class="">
                                <a
                                  href="#"
                                  class="ps-Icon"
                                  @click="
                                    handleSubMenuClick('presource_subMenu')
                                  "
                                >
                                  Project Status
                                  <d-icon
                                    class="menu-chevron-down"
                                    icon="chevron-right"
                                    type="is-primary is-clickable"
                                  />
                                </a>
                              </li>
                              <li>
                                <a
                                  :href="`${this.redirectUrl}woodworkers/qcp-fees/`"
                                  >Project Fees</a
                                >
                              </li>
                              <li>
                                <a :href="`${this.redirectUrl}resources`"
                                  >Resources</a
                                >
                              </li>
                            </ul>
                            <ul
                              class="res-submenu-list-ui submenu-in-res-dd hidden"
                              id="presource_subMenu"
                            >
                              <li>
                                <a href="/forms/project-update"
                                  >Update Project Status</a
                                >
                              </li>
                              <li>
                                <a href="/forms/request-inspection"
                                  >Request Inspection</a
                                >
                              </li>
                              <li>
                                <a href="/forms/project-closeout"
                                  >Close Out Project</a
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="featured-sec-res">
                        <h6 class="mb-5 mt-3">QUALITY CERTIFICATION PROGRAM</h6>
                        <div class="features-res-blurb-list">
                          <div
                            class="features-res-blurb-item flex items-center gap-5 mb-3"
                            @click="handleNavigate('register')"
                          >
                            <div class="reg-project-icon">
                              <d-icon
                                class="featured-icon-cust"
                                icon="clipboard-check"
                                type="is-primary is-clickable"
                              />
                            </div>
                            <div class="features-res-blurb-content">
                              <p>Register Project</p>
                              <span>Submit Architectural Design</span>
                            </div>
                          </div>
                          <div
                            class="features-res-blurb-item flex items-center gap-5 mb-3"
                            @click="handleNavigate('apply')"
                          >
                            <div class="reg-project-icon">
                              <d-icon
                                class="apply-licencing-icon-cust"
                                icon="file"
                                type="is-primary is-clickable"
                              />
                            </div>
                            <div class="features-res-blurb-content">
                              <p>Apply For Licensing</p>
                              <span>Secure Woodworking License</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="w-full flex-grow xl:flex items-center xl:w-auto ml-8 xl:items-center navbar-links flex-wrap justify-end gap-6 main-headermenu-links"
                  :class="{ hidden: !showNavLinks }"
                >
                  <div class="text-md xl:flex block items-center justify-end">
                    <div class="nav-item">
                      <a
                        :href="`${this.redirectUrl}about-awi-qcp`"
                        class="flex items-center gap-2"
                      >
                        About
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"
                          type="is-primary is-clickable"
                        />
                      </a>
                      <ul class="sub-menu" id="about_menu">
                        <li>
                          <a :href="`${this.redirectUrl}about-awi-qcp`">
                            About Us
                          </a>
                        </li>
                        <li>
                          <a
                            :href="`${this.redirectUrl}what-qcp-certification-means`"
                            >What is QCP?</a
                          >
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}leadership`"
                            >Leadership & Staff</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a
                        :href="`${this.redirectUrl}architects-designers`"
                        class="flex items-center gap-2"
                      >
                        Architects
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"
                          type="is-primary is-clickable"
                        />
                      </a>
                      <ul class="sub-menu" id="architects_menu">
                        <li>
                          <a
                            :href="`${this.redirectUrl}architects-designers/how-to-specify-a-qcp-project/`"
                          >
                            How to Specify QCP?
                          </a>
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}project-registration`"
                            >Registering Projects</a
                          >
                        </li>
                        <li>
                          <a
                            :href="`${this.redirectUrl}woodworkers/find-a-qcp-firm/`"
                            >Find Licensed Firms</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;" class="flex items-center gap-2">
                        Licensing
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"
                          type="is-primary is-clickable"
                        />
                      </a>
                      <ul class="sub-menu" id="licensing_menu">
                        <li>
                          <a :href="`${this.redirectUrl}about-licensing`"
                            >About Licensing</a
                          >
                        </li>
                        <li>
                          <a href="/forms/apply-for-licensing"
                            >Apply For License</a
                          >
                        </li>
                        <li>
                          <a
                            :href="`${this.redirectUrl}woodworkers/how-to-get-qcp-licensed/`"
                            >How Licensing Works</a
                          >
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}are-you-qcp-licensed`"
                            >How to Leverage Your License</a
                          >
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}woodworkers/qcp-fees/`"
                            >Licensing Fees</a
                          >
                        </li>
                        <li>
                          <a href="/account/login">Take Test</a>
                        </li>
                        <li>
                          <a href="/forms/renewal">Renew License</a>
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;" class="flex items-center gap-2">
                        Professionals
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"
                          type="is-primary is-clickable"
                        />
                      </a>
                      <ul class="sub-menu" id="professional_menu">
                        <li>
                          <a :href="`${this.redirectUrl}architects-designers/`"
                            >Architects</a
                          >
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}woodworkers/`"
                            >Woodworkers</a
                          >
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}drafters/`">Drafters</a>
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}contractors/`"
                            >General Contractors</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;" class="flex items-center gap-2">
                        Project Resources
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"
                          type="is-primary is-clickable"
                        />
                      </a>
                      <ul class="sub-menu" id="presource_menu">
                        <li>
                          <a href="/forms/register-project"
                            >Why Register a Project?</a
                          >
                        </li>
                        <li>
                          <a href="/forms/project-certification"
                            >Order Project Certification</a
                          >
                        </li>
                        <li class="ps-dd-ui">
                          <a href="#" class="ps-Icon">
                            Project Status
                            <d-icon
                              class="menu-chevron-down ps-Icon"
                              icon="chevron-down"
                              type="is-primary is-clickable"
                            />
                          </a>
                          <div class="project-status-dd-ui">
                            <ul>
                              <li>
                                <a href="/forms/project-update"
                                  >Update Project Status</a
                                >
                              </li>
                              <li>
                                <a href="/forms/request-inspection"
                                  >Request Inspection</a
                                >
                              </li>
                              <li>
                                <a href="/forms/project-closeout"
                                  >Close Out Project</a
                                >
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}woodworkers/qcp-fees/`"
                            >Project Fees</a
                          >
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}resources`"
                            >Resources</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;" class="flex items-center gap-2">
                        More
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"
                          type="is-primary is-clickable"
                        />
                      </a>
                      <ul class="sub-menu" id="more_menu">
                        <li>
                          <a :href="`${this.redirectUrl}news-and-blog/`"
                            >Blog</a
                          >
                        </li>
                        <li>
                          <a
                            :href="`${this.redirectUrl}architectural-woodworking-publications/`"
                            >Publications</a
                          >
                        </li>
                        <li>
                          <a
                            :href="`${this.redirectUrl}a-guide-to-the-awi-standards-of-architectural-woodwork/`"
                          >
                            Guide to AWI Standards
                          </a>
                        </li>
                        <li>
                          <a :href="`${this.redirectUrl}find-a-project/`"
                            >Find Certified Projects</a
                          >
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="header-right-btns">
                  <a
                    href="/forms/apply-for-licensing"
                    class="get-licensed-btn btn-hover-state"
                  >
                    get licensed
                  </a>
                  <a
                    href="/forms/register-project"
                    class="register-project-btn btn-hover-state"
                  >
                    register project
                  </a>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <!-- <nav class="navbar navbar-expand-lg">

                            <a class="navbar-brand" href="https://awiqcp.org/">
                                <img src="https://segalom5.sg-host.com/wp-content/uploads/2023/06/awi-qcp-logo.jpg" width="400"
                                     alt="">
                            </a>

                            <div class="flex items-center">
                                <button class="navbar-toggler" type="button" data-toggle="collapse"
                                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                                        aria-expanded="false" aria-label="Toggle navigation">
                                    <span class="navbar-toggler-icon"></span>
                                </button>
                                <div class="collapse navbar-collapse mr-6" id="navbarSupportedContent">
                                    <ul class="navbar-nav mr-auto">
                                        <li class="nav-item dropdown dropdown-hover">
                                            <a class="nav-link dropdown-toggle flex items-center gap-2" href="javascript:;" id="navbarDropdown"
                                               role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Licensing
                                                <d-icon class="menu-chevron-down" icon="chevron-down"  type="is-primary is-clickable" />
                                            </a>
                                            <div class="sub-menu" aria-labelledby="navbarDropdown">
                                                <a class="dropdown-item" href="#">How To Get Licensed</a>
                                                <a class="dropdown-item" href="#">Apply for Licensing</a>

                                                <a class="dropdown-item" href="#">QCP Licensed Firms</a>
                                                <a class="dropdown-item" href="#">Request Qualifying Credentials</a>
                                                <a class="dropdown-item" href="#">Login</a>
                                                <a class="dropdown-item" href="#">Annual Licensing Renewal</a>
                                                <a class="dropdown-item" href="#">Licensing Fees</a>
                                            </div>

                                        </li>

                                        <li class="nav-item dropdown dropdown-hover">
                                            <a class="nav-link dropdown-toggle flex items-center gap-2" href="#" id="navbarDropdown" role="button"
                                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Certified Projects
                                                <d-icon class="menu-chevron-down" icon="chevron-down"  type="is-primary is-clickable" />
                                            </a>
                                            <div class="sub-menu" aria-labelledby="navbarDropdown">
                                                <a class="dropdown-item" href="#">Register a Project</a>
                                                <a class="dropdown-item" href="#">Update Project Status</a>
                                                <a class="dropdown-item" href="#">Request Project Inspection</a>
                                                <a class="dropdown-item" href="#">Order Project Certification Labels</a>
                                                <a class="dropdown-item" href="#">Close out a QCP Project</a>
                                                <a class="dropdown-item" href="#">QCP Project Fees</a>

                                            </div>
                                        </li>
                                        <li class="nav-item dropdown dropdown-hover">
                                            <a class="nav-link dropdown-toggle flex items-center gap-2" href="#" id="navbarDropdown" role="button"
                                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Professionals
                                                <d-icon class="menu-chevron-down" icon="chevron-down"  type="is-primary is-clickable" />
                                            </a>
                                            <div class="sub-menu" aria-labelledby="navbarDropdown">
                                                <a class="dropdown-item" href="#">Architects / Designers</a>
                                                <a class="dropdown-item" href="#">Woodworkers</a>

                                                <a class="dropdown-item" href="#">Drafters</a>
                                                <a class="dropdown-item" href="#">Drafting Accreditation</a>
                                                <a class="dropdown-item" href="#">Contractors</a>
                                            </div>
                                        </li>
                                        <li class="nav-item dropdown dropdown-hover">
                                            <a class="nav-link dropdown-toggle flex items-center gap-2" href="#" id="navbarDropdown" role="button"
                                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Find A...
                                                <d-icon class="menu-chevron-down" icon="chevron-down"  type="is-primary is-clickable" />
                                            </a>
                                            <div class="sub-menu" aria-labelledby="navbarDropdown">
                                                <a class="dropdown-item" href="#">QCP Licensed Firm</a>
                                                <a class="dropdown-item" href="#">QCP Certified Project</a>


                                            </div>
                                        </li>

                                        <li class="nav-item dropdown dropdown-hover">
                                            <a class="nav-link dropdown-toggle flex items-center gap-2" href="#" id="navbarDropdown" role="button"
                                               data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                Insights
                                                <d-icon class="menu-chevron-down" icon="chevron-down"  type="is-primary is-clickable" />
                                            </a>
                                            <div class="sub-menu" aria-labelledby="navbarDropdown">
                                                <a class="dropdown-item" href="#">News / Blog</a>
                                                <a class="dropdown-item" href="#">Publications</a>

                                                <a class="dropdown-item" href="#">Video Gallery</a>
                                                <a class="dropdown-item" href="#">Podcasts</a>
                                                <a class="dropdown-item" href="#">Resources</a>

                                            </div>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">Contact</a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#">AWI Home</a>
                                        </li>


                                    </ul>

                                </div>
                                <div class="header-right-btns">
                                    <a href="" class="get-licensed-btn btn-hover-state">
                                        get licensed
                                    </a>
                                    <a href="" class="register-project-btn btn-hover-state">
                                        register project
                                    </a>
                                </div>
                            </div>

                        </nav> -->
      </div>
      <!-- <div v-if="currentNavItem" class="mt-2 breadcrumbs w-full relative">
              <div class="py-1 container mx-auto max-w-screen-xl">
                <p id="breadcrumbs" class="text-success m-0 px-0 xl:px-24">
                  <a href="https://awiqcp.org/" class="no-underline">Home</a>
                  <template v-if="parentNavItem">
                    <span key="parent-arrow" class="breadcrumb_arrow">›</span>
                    <a key="parent-link" :href="parentNavItem.getAttribute('href')" class="no-underline">{{
                      parentNavItem.innerText }}</a>
                  </template>
                  <span class="breadcrumb_arrow">›</span>
                  <strong class="breadcrumb_last" aria-current="page">{{
                    currentNavItem.innerHTML
                  }}</strong>
                </p>
              </div>
            </div> -->

      <div class="header-search-bar">
        <div class="flex justify-center align-center header-search-bar-des">
          <div
            class="flex items-center justify-center gap-3 items-search-des-dd"
          >
            <span class="search-bar-label">Search: </span>

            <div class="main-search-header position-relative">
              <input
                type="search"
                class="header-search-input"
                placeholder="Enter Keyword(s)"
                v-model="search"
                @keyup.enter="handleSearch(search)"
                required
              />

              <span class="search-icon-cust">
                <d-icon
                  class="top-bar-search-icon"
                  icon="search"
                  type="is-primary is-clickable"
                  @click="handleSearch(search)"
                />
              </span>

              <span
                class="close-icon-for-search"
                v-if="this.search"
                @click="resetSearchText()"
              >
                <svg
                  width="25px"
                  height="25px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.06 12L17.48 7.57996C17.5537 7.5113 17.6128 7.4285 17.6538 7.3365C17.6948 7.2445 17.7168 7.14518 17.7186 7.04448C17.7204 6.94378 17.7018 6.84375 17.6641 6.75036C17.6264 6.65697 17.5703 6.57214 17.499 6.50092C17.4278 6.4297 17.343 6.37356 17.2496 6.33584C17.1562 6.29811 17.0562 6.27959 16.9555 6.28137C16.8548 6.28314 16.7555 6.30519 16.6635 6.34618C16.5715 6.38717 16.4887 6.44627 16.42 6.51996L12 10.94L7.58 6.51996C7.43782 6.38748 7.24978 6.31535 7.05548 6.31878C6.86118 6.32221 6.67579 6.40092 6.53838 6.53834C6.40096 6.67575 6.32225 6.86113 6.31882 7.05544C6.3154 7.24974 6.38752 7.43778 6.52 7.57996L10.94 12L6.52 16.42C6.37955 16.5606 6.30066 16.7512 6.30066 16.95C6.30066 17.1487 6.37955 17.3393 6.52 17.48C6.66062 17.6204 6.85125 17.6993 7.05 17.6993C7.24875 17.6993 7.43937 17.6204 7.58 17.48L12 13.06L16.42 17.48C16.5606 17.6204 16.7512 17.6993 16.95 17.6993C17.1488 17.6993 17.3394 17.6204 17.48 17.48C17.6204 17.3393 17.6993 17.1487 17.6993 16.95C17.6993 16.7512 17.6204 16.5606 17.48 16.42L13.06 12Z"
                    fill="#ffffff"
                  />
                </svg>
              </span>

              <div class="search-filter-dropdown" v-if="this.search">
                <div
                  class="filter-list-search"
                  v-if="this.page_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Pages</p>
                  </div>

                  <!-- <div class="list-filter-dd">
                    <ul>
                      <li v-for="item in this.page_results_list">
                        <a :href="item.permalink" class="flex gap-2">
                          <div
                            class="dd-pages-thumbnail"
                            v-if="!Array.isArray(item.images)"
                          >
                            <img
                              :src="item.images.thumbnail.url"
                              alt="Post Image"
                            />
                          </div>
                          <span
                            class="pages-title-cust"
                            v-html="item._highlightResult.post_title.value"
                          >
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div> -->
                  <div class="list-filter-posts-dd">
                    <ul>
                      <li v-for="item in this.page_results_list">
                        <a :href="item.permalink" class="post-a-tag">
                          <div class="posts-blurb-in-dd">
                            <img
                              src="https://awinet.org/wp-content/uploads/2023/11/home-video-cover.jpg"
                              alt=""
                              v-if="!item.images.thumbnail"
                            />
                            <img
                              :src="item.images.thumbnail.url"
                              alt=""
                              v-if="item.images.thumbnail"
                            />
                            <div class="posts-blurb-content-ui">
                              <p
                                v-html="item._highlightResult.post_title.value"
                              ></p>

                              <span
                                class="post-summary"
                                v-html="item.revised_content"
                              ></span>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="filter-list-search"
                  v-if="this.post_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Posts</p>
                  </div>

                  <div class="list-filter-posts-dd">
                    <ul>
                      <li v-for="item in this.post_results_list">
                        <a :href="item.permalink" class="post-a-tag">
                          <div class="posts-blurb-in-dd">
                            <img :src="item.images.thumbnail.url" alt="" />

                            <div class="posts-blurb-content-ui">
                              <p
                                v-html="item._highlightResult.post_title.value"
                              ></p>

                              <span
                                class="post-summary"
                                v-html="item._snippetResult.content.value"
                              ></span>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="filter-list-search"
                  v-if="this.standards_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Standards</p>
                  </div>

                  <div class="list-filter-posts-dd">
                    <ul>
                      <li
                        v-for="item in this.standards_results_list"
                        class="standards-list-hover"
                      >
                        <a :href="item.permalink" class="post-a-tag">
                          <div class="posts-blurb-in-dd">
                            <img
                              src="https://awinet.org/wp-content/uploads/2023/11/home-video-cover.jpg"
                              alt=""
                              v-if="!item.images.thumbnail"
                            />
                            <img
                              :src="item.images.thumbnail.url"
                              alt=""
                              v-if="item.images.thumbnail"
                            />

                            <div class="posts-blurb-content-ui">
                              <p
                                v-html="
                                  item.taxonomies_hierarchical
                                    .standards_category.lvl0[0]
                                "
                              ></p>
                              <p
                                v-html="item._highlightResult.post_title.value"
                              ></p>
                            </div>
                          </div>
                          <div
                            class="flex-col posts-blurb-in-dd posts-blurb-content-ui ac-text-bold"
                          >
                            <span
                              class="post-summary"
                              v-for="subItem in item._snippetResult
                                .standards_content"
                              v-if="subItem.matchLevel != 'none'"
                              v-html="subItem.value"
                            ></span>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- <div
                  class="filter-list-search"
                  v-if="this.standards_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Standards</p>
                  </div>

                  <div class="list-filter-dd">
                    <ul>
                      <li v-for="item in this.standards_results_list">
                        <a :href="item.permalink" class="flex gap-1">
                          <span
                            class="pages-title-cust"
                            v-html="item._highlightResult.post_title.value"
                          >
                          </span>
                        </a>
                        
                      </li>
                    </ul>
                  </div>
                </div> -->

                <div
                  class="filter-list-search"
                  v-if="this.standards_category_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Standards Category</p>
                  </div>

                  <div class="list-filter-dd cat-tag-list-ui">
                    <ul>
                      <li
                        v-for="item in this.standards_category_results_list"
                        class="flex items-center gap-1"
                      >
                        <d-icon
                          class="top-bar-search-dd-tag"
                          icon="tag"
                          type="is-primary is-clickable"
                        />
                        <a
                          :href="item.permalink"
                          class="cat-tag-dd-item"
                          v-html="item._highlightResult.name.value"
                        >
                        </a>
                      </li>
                      <!-- <li>How Standards Works</li>

                           <li>Cabinet Design Series</li>

                           <li>Shelf Span</li>

                           <li>Staff</li> -->
                    </ul>
                  </div>
                </div>

                <div
                  class="filter-list-search"
                  v-if="this.glossary_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Glossary</p>
                  </div>

                  <div class="list-filter-posts-dd">
                    <ul>
                      <li v-for="item in this.glossary_results_list">
                        <a :href="item.permalink" class="post-a-tag">
                          <div class="posts-blurb-in-dd">
                            <img
                              src="https://awinet.org/wp-content/uploads/2023/11/home-video-cover.jpg"
                              alt=""
                              v-if="!item.images.thumbnail"
                            />
                            <img
                              :src="item.images.thumbnail.url"
                              alt=""
                              v-if="item.images.thumbnail"
                            />
                            <div class="posts-blurb-content-ui">
                              <p
                                v-html="item._highlightResult.post_title.value"
                              ></p>

                              <span
                                class="post-summary"
                                v-html="item._snippetResult.content.value"
                              ></span>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div
                  class="filter-list-search"
                  v-if="this.category_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Categories</p>
                  </div>

                  <div class="list-filter-dd cat-tag-list-ui">
                    <ul>
                      <li
                        v-for="item in this.category_results_list"
                        class="flex items-center gap-1"
                      >
                        <d-icon
                          class="top-bar-search-dd-tag"
                          icon="tag"
                          type="is-primary is-clickable"
                        />
                        <a
                          :href="item.permalink"
                          class="cat-tag-dd-item"
                          v-html="item._highlightResult.name.value"
                        >
                        </a>
                      </li>

                      <!-- <li>How Standards Works</li>
""
                           <li>Cabinet Design Series</li>

                           <li>Shelf Span</li>

                           <li>Staff</li> -->
                    </ul>
                  </div>
                </div>

                <div
                  class="filter-list-search"
                  v-if="this.terms_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Tags</p>
                  </div>

                  <div class="list-filter-dd cat-tag-list-ui">
                    <ul>
                      <li
                        v-for="item in this.terms_results_list"
                        class="flex items-center gap-1"
                      >
                        <d-icon
                          class="top-bar-search-dd-tag"
                          icon="tag"
                          type="is-primary is-clickable"
                        />
                        <a
                          :href="item.permalink"
                          class="cat-tag-dd-item"
                          v-html="item._highlightResult.name.value"
                        >
                        </a>
                      </li>
                      <!-- <li>How Standards Works</li>

                           <li>Cabinet Design Series</li>

                           <li>Shelf Span</li>

                           <li>Staff</li> -->
                    </ul>
                  </div>
                </div>

                <div
                  class="filter-list-search"
                  v-if="this.salesforce_results_list.length > 0"
                >
                  <div class="dd-title">
                    <p>Member Portal</p>
                  </div>

                  <div class="list-filter-posts-dd">
                    <ul>
                      <li v-for="item in this.salesforce_results_list">
                        <a :href="item.permalink" class="post-a-tag">
                          <div class="posts-blurb-in-dd">
                            <img
                              src="https://awinet.org/wp-content/uploads/2023/11/home-video-cover.jpg"
                              alt=""
                            />
                            <div class="posts-blurb-content-ui">
                              <p
                                v-html="item.post_title"
                              ></p>

                              <span
                                class="post-summary"
                                v-html="item.post_summary"
                              ></span>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- <div id="nav-filler" />  -->
    <!-- <div class="header">
          <nav class="sticky-top top-0 inset-x-0 items-center pt-5 main-nav-des">
            <div class="w-full relative mx-auto">
              <div
                class="flex flex-wrap xl:flex-no-wrap items-center justify-between px-0 xl:px-24"
              >
                <div class="flex items-center xl:mr-4 py-2">
                  <a
                    href="https://awiqcp.org/"
                    class="no-underline text-xl font-bold"
                  >
                    <img
                      src="/dist/images/logo.jpg"
                      class="h-20 max-w-none"
                      alt="AWI Quality Certification Program"
                    />
                  </a>
                </div>

                <div class="block xl:hidden">
                  <button
                    class="navbar-burger flex items-center px-3 py-2 border rounded text-black border-black hover:text-black hover:border-black"
                    @click="showNavLinks = !showNavLinks"
                  >
                    <svg
                      class="fill-current h-3 w-3"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>Menu</title>
                      <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
                    </svg>
                  </button>
                </div>

                <div
                  class="w-full flex-grow xl:flex items-center xl:w-auto ml-8 xl:items-center navbar-links flex-wrap justify-end"
                  :class="{ hidden: !showNavLinks }"
                >
                  <div class="text-md xl:flex block items-center justify-end">
                    <div class="nav-item">
                      <a href="javascript:;">
                        Licensing
                        <d-icon
                          class="menu-chevron-down"
                          icon="chevron-down"

                          type="is-primary is-clickable"
                      /></a>
                      <ul class="sub-menu">
                        <li>
                          <a
                            href="https://awiqcp.org/architects-designers/how-to-specify-a-qcp-project/"
                            >How To Get Licensed</a
                          >
                        </li>
                        <li>
                          <a href="/forms/apply-for-licensing"
                            >Apply for Licensing</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/are-you-qcp-licensed/"
                            >QCP Licensed Firms</a
                          >
                        </li>
                        <li>
                          <a href="/forms/qualify-credentials"
                            >Request Qualifying Credentials</a
                          >
                        </li>
                        <li>
                          <a href="/account/login">Login</a>
                        </li>
                        <li>
                          <a href="/forms/renewal">Annual Licensing Renewal</a>
                        </li>
                        <li>
                          <a href="https://awiqcp.org/woodworkers/qcp-fees/"
                            >Licensing Fees</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="https://awiqcp.org/project-registration/"
                        >Certified Projects</a
                      >
                      <ul class="sub-menu">
                        <li>
                          <a href="/forms/register-project">Register a Project</a>
                        </li>
                        <li>
                          <a href="/forms/project-update">Update Project Status</a>
                        </li>
                        <li>
                          <a href="/forms/request-inspection"
                            >Request Project Inspection</a
                          >
                        </li>
                        <li>
                          <a href="/forms/project-certification/"
                            >Order Project Certification Labels</a
                          >
                        </li>
                        <li>
                          <a href="/forms/project-closeout"
                            >Close out a QCP Project</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/woodworkers/qcp-fees/"
                            >QCP Project Fees</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;">Professionals</a>
                      <ul class="sub-menu">
                        <li>
                          <a href="https://awiqcp.org/architects-designers/"
                            >Architects / Designers</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/woodworkers/">Woodworkers</a>
                        </li>
                        <li>
                          <a href="https://awiqcp.org/drafters/">Drafters</a>
                        </li>
                        <li>
                          <a href="/forms/drafting-accreditation"
                            >Drafting Accreditation</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/contractors/">Contractors</a>
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;">Find A...</a>
                      <ul class="sub-menu">
                        <li>
                          <a href="https://awiqcp.org/woodworkers/find-a-qcp-firm/"
                            >QCP Licensed Firm</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/find-a-project/"
                            >QCP Certified Project</a
                          >
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item">
                      <a href="javascript:;">Insights</a>
                      <ul class="sub-menu">
                        <li>
                          <a href="https://awiqcp.org/news-and-blog/"
                            >News / Blog</a
                          >
                        </li>
                        <li>
                          <a
                            href="https://awiqcp.org/architectural-woodworking-publications/"
                            >Publications</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/video-gallery/"
                            >Video Gallery</a
                          >
                        </li>
                        <li>
                          <a href="https://awiqcp.org/podcasts/">Podcasts</a>
                        </li>
                        <li>
                          <a href="https://awiqcp.org/resources/">Resources</a>
                        </li>
                      </ul>
                    </div>

                    <div class="nav-item xl:pl-2 pl-0">
                      <a href="https://awiqcp.org/contact/">Contact</a>
                    </div>
                    <div class="nav-item xl:pl-2 pl-0">
                      <a href="https://www.awinet.org/">AWI Home</a>
                    </div>
                  </div>
                  <div class="header-right-btns">
                    <a href="" class="get-licensed-btn btn-hover-state">
                      get licensed
                    </a>
                    <a href="" class="register-project-btn btn-hover-state">
                      register project
                    </a>
                  </div>
                </div>
              </div>
            </div>
           <div v-if="currentNavItem" class="mt-2 breadcrumbs w-full relative ">
                        <div class="py-1 container mx-auto  max-w-screen-xl ">
                            <p id="breadcrumbs" class=" text-success m-0 px-0 xl:px-24">
                                <a href="https://awiqcp.org/" class="no-underline">Home</a>
                                <template v-if="parentNavItem">
                                    <span key="parent-arrow" class="breadcrumb_arrow">›</span>
                                    <a key="parent-link" :href="parentNavItem.getAttribute('href')" class="no-underline">{{
                                        parentNavItem.innerHTML }}</a>
                                </template>
                                <span class="breadcrumb_arrow">›</span>
                                <strong class="breadcrumb_last" aria-current="page">{{ currentNavItem.innerHTML }}</strong>
                            </p>
                        </div>
                    </div>
          </nav>
        </div>
        <div id="nav-filler" /> -->
  </div>
</template>

<script>
import algoliasearch from "algoliasearch";

const client = algoliasearch("5EJADFCKSZ", "5ab94270d722e5a497ef0bd585a706f8");
const wp_posts_post = client.initIndex("wp_posts_post");
const wp_posts_page = client.initIndex("wp_posts_page");
const wp_terms_category = client.initIndex("wp_terms_category");
const wp_terms_post_tag = client.initIndex("wp_terms_post_tag");
const wp_posts_standards = client.initIndex("wp_posts_standards");
const wp_terms_standards_category = client.initIndex(
  "wp_terms_standards_category"
);
const wp_posts_glossary = client.initIndex("wp_posts_glossary");
const wp_posts_salesforce = client.initIndex("wp_posts_salesforce");

const indexes = [
  // wp_posts_post,
  // wp_posts_page,
  // wp_terms_category,
  // wp_terms_post_tag,
  wp_posts_page,
  wp_posts_post,
  wp_posts_standards,
  wp_terms_standards_category,
  wp_posts_glossary,
  wp_terms_category,
  wp_terms_post_tag,
  wp_posts_salesforce,
];

const transformSalesforce = (hits) => {
  return hits.map((hit) => {
    let permalink, post_title, post_summary;

    switch (hit.attribute.type) {
      case "acem__Event__c":
        permalink = `https://member.awinet.org/s/event/${hit.Id}`;
        post_title = hit.Name
        post_summary = 'Event';
        break;
      case "Knowledge__kav":
        permalink = `https://member.awinet.org/s/article/${hit.Id}`;
        post_title = hit.Name
        post_summary = 'Article';
        break;
      case "Contact":
        permalink = `https://member.awinet.org/s/profile/${hit.Id}`;
        post_title = hit.FirstName + ' ' + hit.LastName;
        post_summary = 'Contact';
        break;
      case "Product2":
        permalink = `https://member.awinet.org/s/product/${hit.Id}`;
        post_title = hit.Name + ' ' + '(Product)';
        post_summary = hit.Description;
        break;
      case "Product3":
      default:
    }
    return {
      permalink: permalink,
      post_title: post_title,
      post_summary: post_summary,
    };
  });
}

export default {
  parent: true,
  props: {
    url: String,
    userData: {
      type: Object,
      default: () => null,
    },
  },
  data: (x) => ({
    showNavLinks: false,
    showDDRes: false,
    navItems: [],
    currentNavItem: null,
    parentNavItem: null,
    isActive: false,
    search: "",
    redirectUrl: x.url,
    // search_results_list: [],
    post_results_list: [],
    page_results_list: [],
    terms_results_list: [],
    category_results_list: [],
    standards_results_list: [],
    standards_category_results_list: [],
    glossary_results_list: [],
    salesforce_results_list: [],
    userDetails: x.userData,
  }),
  mounted() {
    const path = window.location.pathname;
    const navItems = document.querySelectorAll(".nav-item a");
    console.log(this.userDetails);
    // navItems.forEach((el) => {
    //   // if (el.getAttribute("href").toLowerCase() === path.toLowerCase()) {
    //   el.classList.add("is-page-active");
    //   const parentItem = el.closest(".nav-item");
    //   parentItem.classList.add("is-page-active-parent");
    //   this.parentNavItem = parentItem.querySelector("a");
    //   this.currentNavItem = el;
    // }
    // });
  },
  methods: {
    handleClick() {
      this.isActive = !this.isActive;
    },
    handleSearch(search_term) {
      if (search_term) {
        let search_url = `https://awiqcp.org/?s=${search_term}`;
        window.open(search_url, "_self");
      }
    },
    handleSubMenu(id) {
      document.getElementById("show_presource")?.classList?.add("hidden");

      if (id !== "presource_menu") {
        const navItems = document.getElementById(id);
        const currElementRes = document.getElementById("back-res-ui");
        const newPlace = document.getElementById("dynamic_menu");

        newPlace.innerHTML = navItems.innerHTML;
        const mainMenu = document.getElementById("responsive-side-menu");
        mainMenu.classList.add("hidden");
        document.getElementById("dynamic_menu").classList.remove("hidden");
        currElementRes.classList.remove("hidden");
      } else {
        const mainMenu = document.getElementById("responsive-side-menu");
        const currElementRes = document.getElementById("back-res-ui");
        mainMenu.classList.add("hidden");
        const subMenu = document.getElementById("show_presource");
        const newPlace = document.getElementById("dynamic_menu");
        newPlace.classList.add("hidden");
        subMenu.classList.remove("hidden");
        currElementRes.classList.remove("hidden");
      }
    },
    handleBackBtnRes(parentId, CurrId) {
      const parentElementRes = document.getElementById(parentId);
      const currElementRes = document.getElementById(CurrId);
      const subCurrElementRes = document.getElementById("presource_subMenu");

      currElementRes.classList.add("hidden");
      subCurrElementRes.classList.add("hidden");
      parentElementRes.classList.remove("hidden");
    },
    handleNavigate(navigatePage) {
      let url = window.location.origin;
      if (navigatePage === "register") {
        window.open(url + "/forms/register-project", "_self");
      } else {
        window.open(url + "/forms/apply-for-licensing", "_self");
      }
    },
    handleSubMenuClick(id) {
      document.getElementById(id).classList.remove("hidden");
      document.getElementById("show_presource").classList.add("hidden");
      document.getElementById("dynamic_menu").classList.add("hidden");
    },
    resetSearchText() {
      this.search = "";
    },
  },
  watch: {
    search: function (query) {
      console.log(query);

      const searchPromises = indexes.map((index) => {
        // Perform a search on each index
        return index
          .search(query, {
            hitsPerPage: 5,
            attributesToSnippet: ["content:10", "standards_content:10"],
            highlightPreTag: '<span class="search-highlight">',
            highlightPostTag: "</span>",
          }) // Limit to the top 5 results for each index
          .then(({ hits }) => hits); // Extract the hits (search results)
      });

      Promise.all(searchPromises)
        .then((allHits) => {
          // Combine all the hits from different indexes into a single array
          const combinedHits = allHits.flat();
          // console.log(allHits);
          // console.log(combinedHits);
          // Sort the combined hits by relevance, if needed
          // const sortedHits = combinedHits.sort((a, b) => b._score - a._score);

          // Take the top 5 results from the combined hits
          // const top5Results = sortedHits.slice(0, 5);

          // Handle the top 5 results
          // console.log(allHits);
          // console.log(Array.isArray(allHits[1][0].images));
          this.post_results_list = [...allHits[1]];
          this.page_results_list = [...allHits[0]];
          this.terms_results_list = [...allHits[6]];
          this.category_results_list = [...allHits[5]];
          this.standards_results_list = [...allHits[2]];
          this.standards_category_results_list = [...allHits[3]];
          this.glossary_results_list = [...allHits[4]];
          this.salesforce_results_list = transformSalesforce([...allHits[7]]);
          // this.search_results_list = [...combinedHits];
        })
        .catch((err) => {
          console.error("Error searching across indexes:", err);
        });
    },
  },
};
</script>

<style>
span.search-highlight {
  color: #0d52ba !important;
}

.sticky-header {
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  left: 0;
}
.top-header {
  padding: 5px 35px;
}

.top-left-buttons {
  padding-left: 0;
}

a.top-bar-buttons.with-border-btn.btn-hover-state:hover {
  background-color: #d1c589;
  border-color: #d1c589;
}

.top-bar-menu-links ul.navbar-nav li.nav-item a.nav-link {
  font-size: 0.65em;
}

.top-left-buttons a.top-bar-buttons.with-bg-btn:hover {
  background-color: #fff;
}

.top-left-buttons a.top-bar-buttons.with-bg-btn,
.top-left-buttons a.top-bar-buttons.with-border-btn {
  border-radius: 0;
}

.header-search-bar {
  padding: 7px;

  background-color: rgb(247, 247, 247);
  z-index: 9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.header-search-bar .main-search-header input.header-search-input:focus-visible {
  outline: 0;
}

.header-search-bar span.search-bar-label {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0em;
  text-transform: none;
  color: #00483a;
  font-family: "Plus Jakarta Sans", sans-serif;
}

.header-search-bar .main-search-header .search-icon-cust {
  position: absolute;
  left: 13px;
  top: 10px;
  font-size: 14px;
  color: #adadad;
}

span.close-icon-for-search {
  color: rgba(255, 255, 255, 1);
  font-size: 0.8em;
  background-color: rgba(0, 0, 0, 0.25);
  font-weight: 400 !important;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 7px;
  cursor: pointer;
}

.header-search-bar .main-search-header {
  border: 1px solid rgba(173, 173, 173, 0.42);
  border-radius: 50px;
  padding: 2px 6px 2px 40px;
  display: flex;
  position: relative;
  height: 40px;
  background: #fff;
}

.header-search-bar .main-search-header input.header-search-input {
  background: transparent;
  width: 100%;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  color: #9a9a9a;
}

.main-search-header {
  width: 27%;
}

.header-search-bar .header-search-bar-des {
  width: 100%;
  justify-content: center;
  align-items: center;
}

.items-search-des-dd {
  width: 100%;
}

/* End Searchbar */

.main-headermenu-links ul.sub-menu a.is-page-active {
  background: #c4af6c;
  margin-right: 0px !important;
}

.top-bar-search {
  position: relative;
}

.top-bar-search span.d-icon.top-bar-search-icon {
  position: absolute;
  top: 7px;
  left: 10px;
  color: #555;
  font-size: 13px;
}

.top-bar-search input[type="search"] {
  padding: 2px 0px 1px 30px;
  border-radius: 50px;
}

.top-bar-search input::placeholder {
  font-size: 1rem;
  font-style: normal;
  font-weight: inherit;
  line-height: 1.3;
  color: rgba(0, 0, 0, 0.5);
}

.search-filter-dropdown {
  position: absolute;
  width: 100% !important;
  top: 45px;
  background: #fff;
  max-height: 500px;
  overflow: auto;
  z-index: 9999999;
  border: 1px solid rgba(173, 173, 173, 0.42);
  left: -140px;
  min-width: 800px;
  border-radius: 30px;
}

input[type="search"]::-webkit-search-cancel-button {
  display: none;
}

.filter-list-search {
  width: 100% !important;
  padding: 0px;
}

.filter-list-search .dd-title p {
  font-size: 13px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: 600;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(173, 173, 173, 0.42);
  padding-bottom: 5px;
  font-family: "Lato";
  color: #000;
}

.filter-list-search .dd-title {
  width: 95%;
  padding: 15px 15px 0px;
}

.list-filter-posts-dd ul {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.list-filter-dd ul li a {
  font-size: 13px;
  line-height: 23px;
  font-weight: 600;
  cursor: pointer;
  cursor: pointer;
  padding: 2px 15px;
  color: #000;
  text-decoration: none;
  display: block;
}

.list-filter-dd ul li a:hover {
  background-color: #f5f5f5;
  color: #d57642;
}

.list-filter-posts-dd {
  width: 100% !important;
}

.list-filter-posts-dd .posts-blurb-in-dd {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: start;
}

.list-filter-posts-dd .posts-blurb-in-dd img {
  width: 35px;
  height: 35px;
}

.posts-blurb-content-ui p {
  font-size: 13px;
  line-height: 13px;
  font-weight: 600;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  width: 100%;
  color: #000;
  text-decoration: none;
}

.posts-blurb-content-ui span {
  font-size: 13px;
  line-height: 22px;
  color: #505050;
}

.post-a-tag {
  text-decoration: none;
}

.top-bar-menu-links ul.navbar-nav {
  gap: 2rem;
}

.top-bar-menu-links ul.navbar-nav li.nav-item a.nav-link {
  font-size: 10.5px;
  letter-spacing: 1.5px;
  margin-right: 0px;
  display: flex;
}

.top-left-buttons a.top-bar-buttons {
  font-size: 9.8px;
  padding-top: 0.23rem;
  padding-right: 1.7rem;
  padding-bottom: 0.23rem;
  padding-left: 1.7rem;
  color: #fff;
  letter-spacing: 1.47px;
  font-family: "Plus Jakarta Sans", sans-serif;
  text-decoration: none;
}

.header {
  background: rgb(255, 255, 255) !important;
  width: 100%;
  padding: 0px 56px;
}

.main-nav-des .navbar-links .nav-item a {
  margin-right: 0px;
}

.main-nav-des .navbar-links .nav-item {
  font-size: 12.6px;
}

.header nav .nav-item a {
  padding: 32px 17px;
}

.main-nav-des .navbar-links .nav-item .sub-menu li a,
.navbar-nav li.nav-item.dropdown.dropdown-hover .sub-menu a.dropdown-item {
  background-color: #00483a;
  padding-top: 1em;
  padding-bottom: 1em;
  border-bottom: 2px solid #266357;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  font-family: "Lato", sans-serif;
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.035em;
}

.main-nav-des .navbar-links .nav-item .sub-menu li a:hover {
  background-color: #c2b364;
}

.main-nav-des .navbar-links .nav-item .sub-menu {
  top: 84px;
  width: 15rem;
  animation: navSubMenuAnim 0.5s ease 0s 1 normal forwards;
}

@keyframes navSubMenuAnim {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.top-bar-menu-links ul {
  padding-right: 1em;
}

a.register-project-btn.btn-hover-state {
  font-weight: 800;
  padding-top: 9px;
  padding-right: 20px;
  padding-bottom: 9px;
  padding-left: 20px;
  letter-spacing: 1.68px;
}

a.get-licensed-btn.btn-hover-state {
  padding-top: 9px;
  padding-right: 20px;
  padding-bottom: 9px;
  padding-left: 20px;
  letter-spacing: 1.68px;
  font-size: 11.2px;
}

.res-menu-dropdown
  .res-quick-links
  ul.res-quick-link-list
  li.res-quick-link-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.res-menu-dropdown
  .res-quick-links
  ul.res-quick-link-list
  li.res-quick-link-item
  a {
  font-family: "Plus Jakarta Sans";
  font-size: 16px;
}

.res-menu-dropdown .res-quick-links h6 {
  margin-bottom: 0.9em !important;
  margin-top: 1.5em;
  font-size: 12.8px;
}

.features-res-blurb-list .features-res-blurb-item .features-res-blurb-content p,
.features-res-blurb-list
  .features-res-blurb-item
  .features-res-blurb-content
  span {
  font-family: "Plus Jakarta Sans";
}

.features-res-blurb-list
  .features-res-blurb-item
  .features-res-blurb-content
  span {
  font-size: 12px;
  line-height: 12px;
  white-space: nowrap;
}

.submenu-in-res-dd {
  width: 100%;
  background-color: #02281f;
  animation: resSubAnim 0.5s ease 0s 1 normal forwards;
}

@keyframes resSubAnim {
  0% {
    opacity: 0;
    transform: translateX(50px);
  }

  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

.back-btn-res {
  color: #fff;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px;
  cursor: pointer;
}

ul.res-submenu-list-ui li a {
  color: #fff !important;
  padding-top: 0.75rem;
  padding-right: 0.75em;
  padding-bottom: 0.75em;
  padding-left: 0.75em;
  text-decoration: none;
  display: block;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 16px;
}

.project-status-dd-ui {
  position: absolute;
  right: -240px;
  width: 15rem;
  font-size: 13px;
  background-color: rgb(4, 4, 4);
  top: 0;
}

li.ps-dd-ui {
  position: relative;
}

.project-status-dd-ui {
  opacity: 0;
  visibility: hidden;
}

li.ps-dd-ui:hover .project-status-dd-ui {
  opacity: 1;
  visibility: visible;
}

a.ps-Icon {
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}

a.ps-Icon span.d-icon.menu-chevron-down {
  font-size: 14px;
  color: #80a49d;
}

.features-res-blurb-item {
  cursor: pointer;
}

.main-menu-hamburger .burger input:checked ~ span:first-of-type {
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  top: 0px;
  left: 6px;
  background: rgba(0, 0, 0, 0.5);
}

.ham-menu-btn {
  box-shadow: none !important;
}
.main-menu-hamburger .burger {
  width: 30px;
  height: 20px;
}

.main-menu-hamburger .burger span {
  height: 3px;
}

.main-menu-hamburger .burger span {
  background-color: rgba(0, 0, 0, 1);
}

.main-menu-hamburger .burger input:checked ~ span:nth-of-type(3) {
  top: 21px;
  left: 5px;
  background: rgba(0, 0, 0, 0.5);
}

.ham-menu-btn:focus-visible {
  outline: none;
  border: 0px;
}

.ham-menu-btn:focus {
  outline: none;
}

li.res-quick-link-item:hover,
.res-submenu-list-ui li:hover {
  background-color: #c2b264 !important;
  cursor: pointer;
}

.ham-menu-btn:hover .main-menu-hamburger span {
  background-color: rgba(0, 0, 0, 0.5);
}

.posts-blurb-in-dd {
  padding: 5px 15px;
  cursor: pointer;
}

.posts-blurb-in-dd:hover {
  background-color: #f5f5f5;
}

.posts-blurb-in-dd:hover .posts-blurb-content-ui p {
  color: #d57642;
}

.posts-blurb-in-dd .posts-blurb-content-ui span {
  /* overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    width: 100%; */
}

.list-filter-posts-dd .posts-blurb-in-dd img {
  border-radius: 5px;
}

a.cat-tag-dd-item {
  /* width: 100%; */
  /* display: flex !important; */
  /* align-items: center; */
  /* gap: 4px; */
}

.top-bar-search-dd-tag {
  color: #bfbfbf;
  transform: rotate(90deg);
  font-size: 13px;
}

.list-filter-dd.cat-tag-list-ui ul {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.features-res-blurb-list
  .features-res-blurb-item
  .features-res-blurb-content
  p {
  font-size: 19.2px;
}

.features-res-blurb-item {
  gap: 0.8rem !important;
}

.features-res-blurb-item:nth-last-child(1) .features-res-blurb-content p {
  font-size: 18.08px;
}

.list-filter-dd.cat-tag-list-ui ul li a {
  padding: 0;
}

.list-filter-dd.cat-tag-list-ui ul li:hover {
  background-color: #f5f5f5;
  /* padding: 1px 15px; */
}

.list-filter-dd.cat-tag-list-ui ul li {
  /* background-color: #f5f5f5; */
  padding: 1px 15px;
}

.posts-blurb-content-ui .post-summary .search-highlight {
  position: relative;
  color: #505050 !important;
}

.posts-blurb-content-ui .post-summary .search-highlight::after {
  content: "";
  width: 100%;
  position: absolute;
  bottom: 0px;
  display: block;
  border-bottom: 2px solid #0067ff;
  left: 0;
}

.dd-pages-thumbnail {
  display: block;
  max-width: 35px;
  max-height: 35px;
  margin-bottom: 10px;
}

.dd-pages-thumbnail img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
}

span.pages-title-cust {
  white-space: nowrap;
  width: 99%;
  overflow: hidden;
  text-overflow: ellipsis;
}

span.post-summary {
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  width: 100%;
  font-size: 13px;
}

span.close-icon-for-search {
  width: 2em;
  height: 2em;
  margin-top: 0.2em;
  margin-right: 0.1em;
  margin-bottom: 0.5em;
  border: 0;
  color: rgba(255, 255, 255, 1);
  font-size: 0.9em;
  background-color: rgba(0, 0, 0, 0.25);
  border-radius: 50%; /* Makes the element circular */
}

span.close-icon-for-search svg {
  max-width: 20px;
}

span.close-icon-for-search:hover {
  background-color: rgba(0, 0, 0, 0.3);
}

a.cat-tag-dd-item {
  white-space: nowrap;
  width: 99%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-header .navbar-nav li.nav-item.dropdown.dropdown-hover .sub-menu {
  top: 27px !important;
  min-width: 150px;
  left: -80px;
}

.top-header li.nav-item.dropdown.dropdown-hover {
  padding: 6px 0px;
}

.ac-text-bold {
  gap: 0px !important;
}

.ac-text-bold .post-summary {
  font-weight: 600 !important;
}

li.standards-list-hover:hover {
  background-color: #f5f5f5;
}

@media (max-width: 1536px) {
  .main-headermenu-links .nav-item:nth-last-child(2),
  .main-headermenu-links .nav-item:nth-last-child(1) {
    display: block;
  }
  .search-filter-dropdown {
    /* width: 67% !important; */
    left: -210px;
  }
}

@media (max-width: 1366px) {
  .header {
    padding: 0px 20px;
  }
}

@media (max-width: 1200px) {
  .header-search-bar div {
    width: 70%;
  }
}

@media (max-width: 1024px) {
  .header-search-bar div {
    width: 80%;
  }
}

@media (max-width: 768px) {
  .header-search-bar div {
    width: 95%;
  }

  .search-filter-dropdown {
    min-width: unset !important;
    width: 90% !important;
    left: 12px;
  }
}

@media (max-width: 600px) {
  .top-header .top-bar-number {
    display: none;
  }

  .top-header {
    padding: 5px 35px;
  }
}

@media (max-width: 500px) {
  .res-quick-links {
    padding-top: 2.25em !important;
    padding-right: 2.25em !important;
    padding-bottom: 1.75em !important;
    padding-left: 2.25em !important;
  }

  .featured-sec-res {
    padding: 1.8rem !important;
  }

  .features-res-blurb-item {
    padding: 1px;
  }

  .list-filter-dd ul li a {
    font-size: 11px;
    line-height: 22px;
  }

  .filter-list-search .dd-title p {
    margin-bottom: 5px;
  }

  .posts-blurb-content-ui p {
    font-size: 12px;
  }
  span.post-summary {
    font-size: 11px;
  }

  .filter-list-search .dd-title {
    width: 100%;
  }

  .dd-pages-thumbnail {
    max-width: 31px;
    max-height: 31px;
  }

  .list-filter-posts-dd .posts-blurb-in-dd img {
    width: 32px;
    height: 32px;
  }
}

@media (max-width: 400px) {
  .top-bar-search {
    display: none;
  }
}
</style>
